//组件类型
export enum CompType {
  none = "none", //无组件
  banner = "banner", //横幅
  //banner_s = "banner_s", //横幅小
  carousel = "carousel", //轮播图
  game_list = "game_list", //游戏列表
  provider_list = "provider_list", //提供商列表
  //recent_wins = "recent_wins", //最近获奖
  search = "search", //搜索
  //activity = "activity", //活动
  marquee = "marquee", //跑马灯
  game_nav = "game_nav", //游戏导航
  bet_game = "bet_game", //投注游戏
  maker_list = "maker_list", //厂商列表
  game_entry = "game_entry", //游戏入口
  winner = "winner", //赢钱模块
  sport = "sport", //体育
  //pay = "pay", //支付
  media = "media", //媒体
  seo = "seo", //SEO
  policy = "policy", //政策
  promote = "promote", //宣传图
  foot_info = "foot_info", //页脚信息
  bet_record = "bet_record", //投注组件
  guess_you_like = "guess_you_like", //猜你喜欢
  custom_list = "custom_list", //自定义列表
  champion_ship = "champion_ship", //锦标赛
  competition = "competition", // 竞标赛
}

//组件状态
export enum CompStatus {
  disable = 0,
  enable = 1,
}
//登录限制
export enum LoginType {
  None = 1, // 不限制
  Logged = 2, // 已登录
  UnLogged = 3, // 未登录
}
//充值限制
export enum RechargeType {
  None = 1, // 不限制
  Recharge = 2, // 充值
  UnRecharge = 3, // 不充值
}
// 点击跳转类型
export enum ClickType {
  None = 0, // 无功能
  ExternalLink = 1, // 跳转外部链接
  Page = 2, // 跳转页面
  Popup = 3, // 跳转弹窗
  Game = 4, // 跳转打开游戏
  LiveChat = 5, // 跳转live-chat客服
  InternalDoc = 6, // 跳转内部文档
  InternalPopup = 8, // 打开内部弹窗
  PageScroll = 7, // 滚动页面至指定位置，后端无此类型
  GameList = 9, // 跳转游戏列表
  TextPopup = 10, // 跳转文本弹窗
  ChatRoom = 11, // 打开聊天室
  PlatGames = 12, // 打开厂商游戏列表
  PWA = 13, // 打开PWA下载链接
  APP = 14, // 打开APP下载链接
  Telegram = 15, // 打开tg群
  AUTODeposit = 16, // 一键自动充值
}

//代理限制
export enum DenyPackType {
  NoLimit = -1, //不限制，
  ExcludeChannel = 0, // 排除渠道
  IncludeChannel = 1, // 包含渠道
  ExcludeAgent = 2, // 排除总代
  IncludeAgent = 3, // 包含总代
}

//game_list 厂商样式
export enum ProviderStyle {
  Default = "", //默认
  None = "1", // 无
  ProgramStyle = "2", // 程序字
  GreenStyle = "3", // 绿色
  WhiteStyle = "4", // 白色
  GrayStyle = "5", // 灰色
  TopStyle = "6", // 顶部
}

//game_list 游戏图标样式
export enum GameIconStyle {
  Default = "", //默认
  Rect = "1", // 矩形
  Square = "2", // 方形
  SquareBottom = "3", // 正方形留底
  RectHorizontal = "4", // 横向长方形
  Top10 = "5", // Top10
}
// 活动枚举
export enum ActivityTypeDescEnum {
  vipLevel = "vip_level", //等级
  vipCoin = "vip_coin", //升级所需经验
  vipUpgradeReward = "vip_upgrade_reward", // 31:升级奖励
  vipDailyRebate = "vip_daily_rebate", // 27:现金回馈
  lossRebate = "loss_rebate", // 42:亏损返现
  vipWeeklyRebate = "vip_weekly_rebate", //周反水 活动24
  vipMonthlyRebate = "vip_monthly_rebate", //月返现 活动40
  dailyReward = "daily_reward", // 23:每日奖励
  weeklyReward = "weekly_reward", // 24:每周奖励
  monthlyReward = "monthly_reward", // 25:每月奖励
}
//活动枚举
export enum ActivityTypeEnum {
  roulette = 5, //转盘活动
  vipMonthBonus = 25, //vip月奖金
  vipRebate = 27, //vip日投注返利
  checkIn = 28, //循环七日签到
  vipCheckIn = 61, //vip签到
  vipWeekly = 29, //VIP活动-周奖金
  vipMonth = 40, //VIP活动-月投注返利
  vipLossRebate = 42, //VIP活动-亏损返现
  redpacket = 45, //红包雨
  inviteChest = 30, //邀请宝箱
  vipUpgrade = 31, //VIP活动-升级奖励

  proxyAward = 33, //代理活动-投注佣金
  proxyAward2 = 60, //代理活动-投注佣金2
  disRecharge3 = 36, //代理活动-存款佣金
  inviteUsers = 37, //代理活动-邀请新用户佣金
  inviteUsersVip = 38, //代理活动-VIP升级佣金
  interactiveTask = 66, //运营引流活动	interactiveTask = 66, //运营引流活动
  cashFlop = 43, //拼多多邀请转盘
  inviteWheel = 12, //代理活动-邀请转盘
  inviteWheel2 = 22, //代理活动-邀请转盘
  newCheckIn = 47, //新人七日签到
  unlimitedProxy = 48, //代理活动-无限级代理
  vipRealTimeRebate = 51, //VIP活动-实时返利
  register = 34, //注册活动
  reliefFund = 52, //救济金-免费救济
  tournament = 54, //锦标赛活动
  reliefFund2 = 55, //救济金2-充值救济
  newSurprise = 56, //新人累积充值
  regRoulette = 58, //注册赠送转盘
  newDeposit = 59, //新用户连续充值
  vipWeeklyRebate = 24, //vip周返水
  weeklyRebate = 76, //周体育投注返利
  vipDayBonus = 23, //vip日奖金
  bossChallenge = 41, //BOSS悬赏令
  appdownload = 26, //下载活动
  firstDeposit = 13, //新首充活动
  shakeRedPacket = 8, //摇一摇红包活动
  dailyLossRebate = 16, //日亏损返现
  reliefFund3 = 19, //救济金3
  dragonTreasure = 15, //恶龙的宝藏活动
  wagerContestDay = 62, //投注比赛活动日
  wagerContestDayCasino = 68, //投注比赛活动日Casino
  wagerContestDaySport = 69, //投注比赛活动日体育
  wagerContestWeek = 63, //投注比赛活动周
  wagerContestWeekCasino = 70, //投注比赛活动周Casino
  wagerContestWeekSport = 71, //投注比赛活动周体育
  wagerContestMonth = 64, //投注比赛活动月
  wagerContestMonthCasino = 72, //投注比赛活动月Casino
  wagerContestMonthSport = 73, //投注比赛活动月体育
  dayRebate = 67, //日投注返利
  supremacy = 74, //争霸赛
  mysteriousRewards = 77, //神秘彩金活动
  vipWeeklyCard = 75, //VIP周卡
  luckyNumberDraw = 78, //幸运码大抽奖

  cashWheel = 17, //现金转盘
  newbieWheel = 18, //新手转盘
  gachapon = 20, //扭蛋活动

  vipDayDeposit = 65, //VIP每日首充活动
  inviteCodeActivity = 79, //口令红包
  sevenNewTask = 80, //7天新手任务
  superValueGiftBox = 83, //超值礼盒
  flipCard = 92, //裂变(翻卡)活动
  dailyCashbackExperience = 93, //每日返现体验
  dailyLossBack = 94, // 新用户日亏损返现

  vipHost = 6001, //前端自定义活动ID
  vipExclusive = 6002, //前端自定义活动ID
  vipLuxury = 6003, //前端自定义活动ID
  InviteWheel4 = 401,

  freeBet = 999999999, //免费投注道具
  manualBonus = 999999998, //手动兑换彩金
  wagerContest = 626364, //投注比赛活动奖金中心

  propsItem = 100000000086, //道具
}

export enum AgentActivityTypeEnum {
  teamAgent = 601, //团队代理活动-团队代理
  // teamDashboard = 6002, //团队代理-团队看板
  // teamMyRewards = 6003, //团队代理-我的奖励
  // teamInvitationRewards = 6004, //团队代理-邀请奖励
  // teamInviteRewards = 6005, //团队代理-被邀请奖励
  // teamRules = 6006, //团队代理-规则
}

export enum BonusBgMode {
  blue = 1, //蓝
  cyanBlue = 2, //青
  red = 3, //红
  yellow = 4, //黄
  green = 5, //绿
  roseRed = 6, //玫红
}

export enum ActivityDetailStatus {
  close = 1, //未开始
  canReceive = 2, // 可领取
  canComplete = 3, // 可完成
  check = 4, //一般查看状态
  countdown = 5, // 倒计时
  Locked = 6, // 未解锁
  Finish = 7, // 活动已结束
  toReceive = 8, //待领取
  disabled = 9, //不可领取
}

export enum BonusCategoryCtrl {
  Normal = 1, //普通奖金
  Vip = 2, //VIP奖金
  Special = 3, //特色奖金
}

export enum RepeatActivityEnum {
  downloadPopup = 303, // 下载活动 Popup
}

//奖金类型分类
export enum BonusCategoryType {
  Roulette = 5, //幸运转盘
  ShakeRedpack = 8, //摇现金
  dragonTreasure = 15, //恶龙的宝藏
  VipDailyLossRebate = 16, //日亏损返现
  CashWheel = 17, //现金转盘
  GachaponGrandPrize = 20, //扭蛋
  VipDailyBonus = 23, //日奖金
  VipWeekBetRebate = 24, //周投注反水
  VipMonthBonus = 25, //月奖金
  VipBetRebate = 27, //投注返回
  CheckIn = 28, //签到
  VipWeeklyBonus = 29, //周奖金
  InviteChest = 30, //邀请宝箱
  VipUpgrade = 31, //VIP升级
  VipMonthBetRebate = 40, //月投注反水
  VipLossRebate = 42, //亏损返现
  MoneyRain = 45, //红包雨
  ReliefFund = 55, // 救济金
  DailyRace = 62, //日竞赛
  WeeklyRace = 63, //周竞赛
  MonthlyRace = 64, //月竞赛
  CasinoDayRace = 68, //赌场日竞赛
  SportDayRace = 69, //体育日竞赛
  CasinoWeekRace = 70, //赌场周竞赛
  SportWeekRace = 71, //体育周竞赛
  CasinoMonthlyRace = 72, //赌场月竞赛
  SportMonthlyRace = 73, //体育月竞赛
  vipWeeklyCard = 75, //VIP周卡
  weeklyRebate = 76, //周体育返利
  sevenNewTask = 78, //周体育返利
  superValueGiftBox = 83, //超值礼盒
  DepositBonus = 100, //存款奖励
  Special = 200, //特色奖金
}

//奖金分类类型
export const BonusCategoryConfig: Record<number, number> = {
  [BonusCategoryType.Roulette]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.CheckIn]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.InviteChest]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.DepositBonus]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.dragonTreasure]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.MoneyRain]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.ShakeRedpack]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.CashWheel]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.GachaponGrandPrize]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.ReliefFund]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.DailyRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.WeeklyRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.MonthlyRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.CasinoDayRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.SportDayRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.CasinoWeekRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.SportWeekRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.CasinoMonthlyRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.SportMonthlyRace]: BonusCategoryCtrl.Normal,
  [BonusCategoryType.superValueGiftBox]: BonusCategoryCtrl.Normal,

  [BonusCategoryType.VipDailyBonus]: BonusCategoryCtrl.Vip,
  [BonusCategoryType.VipDailyLossRebate]: BonusCategoryCtrl.Vip,
  [BonusCategoryType.VipBetRebate]: BonusCategoryCtrl.Vip,
  [BonusCategoryType.VipMonthBonus]: BonusCategoryCtrl.Vip,
  [BonusCategoryType.VipLossRebate]: BonusCategoryCtrl.Vip,
  [BonusCategoryType.VipMonthBetRebate]: BonusCategoryCtrl.Vip,
  [BonusCategoryType.VipUpgrade]: BonusCategoryCtrl.Vip,
  [BonusCategoryType.VipWeekBetRebate]: BonusCategoryCtrl.Vip,
  [BonusCategoryType.VipWeeklyBonus]: BonusCategoryCtrl.Vip,

  [BonusCategoryType.Special]: BonusCategoryCtrl.Special,
};
// 道具
export enum PropEnum {
  deposit = 1, //充值优惠
  point = 2, //赠送金额---作废
  roulette = 3, //转盘道具---作废
  vipMul = 4, //VIP积分翻呗---作废
  vipAdd = 5, //VIP积分赠送
  freeBet = 6, //免费投注
  activity = 7, //参与次数
  tournamentTicket = 8, //争霸赛门票
  vipLevelAdd = 9, //VIP等级直升道具
  casualGame = 10, //休闲游戏
}

export enum PropQueryStatus {
  all = -1, //全部
  notUsed = 0, //未使用
  using = 1, //已使用-1.全部, 0.未使用, 1.使用中, 2.已使用, 3.已过期
  used = 2, //已使用-1.全部, 0.未使用, 1.使用中, 2.已使用, 3.已过期
  expire = 3,
}
// 免费旋转道具
export enum promoActivityType {
  luckyWheel = 5, //幸运转盘
  carnivalMasks = 50, //狂欢节面具
  cashWheel = 17, //现金转盘
  crazyGachapon = 20, //扭蛋活动
}

//Infinite状态
export enum InfiniteTypeEnum {
  loading = 0,
  init = 1,
  complete = 2,
  loaded = 3,
  error = 4,
}

//分享社媒ID
export enum ipatypeEnum {
  link = 0,
  sms = 1,
  tiktok = 2,
  ins = 3,
  telegram = 4,
  facebook = 5,
  twitter = 6,
  whatsapp = 7,
  kwai = 8,
  bluesky = 9,
}

// 证件类型
export enum IdentifyType {
  cpf = 1,
  CNPJ = 2,
  DNI = 3,
  PAS = 4,
  CEBILU = 5, //CE秘鲁
  RUC = 6,
  CC = 7,
  CEGLBY = 8,
  CURP = 9,
}

// 用户KYC权限检查
export enum UserKycAuthActionType {
  withdraw = 1,
  resetpwd,
  exclusion,
  bet,
  deposit,
  login,
  register,
  changData,
  noActivity,
  changeBindEmail,
  cpfResetPwd, // 后台没有配置
  loginByFaceIndex, // 人脸识别登录 后台没有配置
}

// CPF
export enum UserIdentifyCheckType {
  no = 0, // 关闭
  save = 1, // 保存
  bind = 2, // 绑定
  verify = 3, // 校验
}

export enum KYCVerifyStatusResult {
  none = 0, // 未开始
  pendding = 1, // 验证中
  fail = 2, // 验证失败
  success = 3, // 验证成功
}

// KYC厂商
export enum KycProvider {
  serasaexperian = 1,
  bigData = 2,
  sumSub = 3,
  legitimuz = 4,
  myid = 5,
  veriff = 6,
}

// KYC结果状态
export enum KycStatusEnum {
  NoVerify = 0, //0.未验证
  PrimarySuc = 1, //1.初步验证成功
  PrimaryFailed = 2, //2.初步验证失败
  AdvanceVerifying = 3, //3.高级验证中
  AdvanceFailed = 4, //4.高级验证失败
  PrimaryVerifying = 99, //初步验证中【后端没有】
  AdvanceSuc = 100, //高级验证成功【后端没有】
}

// 七天新手任务类型
export enum sevenNewTaskType {
  SevenNewTaskJumpTransaction = 1001, // 跳转交易记录页面
  SevenNewTaskJumpVipList = 1002, // 跳转奖励中心-VIP列表
  SevenNewTaskJumpWeeklyVipCashBackOnLosses = 1003, // 跳转周亏返活动详情页
  SevenNewTaskJumpCashFlop3 = 1004, // 跳转邀请转盘3详情页
  SevenNewTaskJumpFeedback = 1005, // 跳转意见反馈页面
  SevenNewTaskJumpInsideMessage = 1006, // 跳转站内信页面
  SevenNewTaskJumpInsideHelp = 1007, // 跳转帮助页面
  SevenNewTaskJumpAgentIndex = 1008, // 跳转代理首页
  SevenNewTaskJumpAgentTeam = 1009, // 跳转团队代理
  SevenNewTaskJumpAgentUser = 1010, // 跳转批量代理
  SevenNewTaskJumpUnlimitedAgent = 1011, // 跳转无限代理
  SevenNewTaskJumpWinWinInvite = 1012, // 跳转双赢邀请
  SevenNewTaskJumpInviteTreasureBox = 1013, // 跳转邀请宝箱
  SevenNewTaskJumpRecommendReward = 1014, // 跳转推荐奖励
  SevenNewTaskJumpUpdateReward = 1015, // 跳转升级奖励
  SevenNewTaskJumpPutCommission = 1016, // 跳转存款佣金
  SevenNewTaskJumpRatesAndRules = 1017, // 跳转费率与规则

  SevenNewTaskBetAll = 2001, // 投注（累计）
  SevenNewTaskBetToday = 2002, // 投注（当日）
  SevenNewTaskInviteCount = 2003, // 邀请（注册人数）
  SevenNewTaskInviteValid = 2004, // 邀请（有效用户人数）
  SevenNewTaskPayAll = 2005, // 存款（累计总金额）
  SevenNewTaskPayTodayRepeat = 2006, // 存款（当日存款笔数）
  SevenNewTaskPaySingle = 2007, // 存款（单笔金额）
  SevenNewTaskPutAll = 2008, // 提现（累计金额）
  SevenNewTaskPutCount = 2009, // 提现（提现笔数）
  SevenNewTaskPutSingle = 2010, // 提现（单笔金额）
  SevenNewTaskPayAllRepeat = 2011, //  存款（累计存款笔数）

  SevenNewTaskVipLevel = 3001, // VIP等级
  SevenNewTaskBindPhone = 3002, // 绑定电话
  SevenNewTaskBindEmail = 3003, // 绑定邮箱
  SevenNewTaskAppLogin = 3004, // APP登录
  SevenNewTaskPassKyc = 3005, // 验证KYC
}

/**
 * Btn_type 映射说明（按 IpatypeEnum 枚举值顺序）:
 *
 * - IpatypeEnum.tiktok (2) -> tiktok_btn_clk -> tiktok按钮_点击
 * - IpatypeEnum.ins (3) -> Instagram_btn_clk -> Instagram按钮_点击
 * - IpatypeEnum.telegram (4) -> telegram_btn_clk -> telegram按钮_点击
 * - IpatypeEnum.facebook (5) -> facebook_btn_clk -> facebook按钮_点击
 * - IpatypeEnum.whatsapp (7) -> whatsapp_btn_clk -> whatsapp按钮_点击
 * - IpatypeEnum.kwai (8) -> kuaishou_btn_clk -> 快手按钮_点击
 * - IpatypeEnum.bluesky (9) -> bluesky_btn_clk -> bluesky按钮_点击
 */
export const IPATYPE_KEY: string = "btn_type";
export const IpatypeEventMapping: Record<ipatypeEnum, [string, number] | []> = {
  [ipatypeEnum.link]: [],
  [ipatypeEnum.sms]: [],
  [ipatypeEnum.tiktok]: [IPATYPE_KEY, 7],
  [ipatypeEnum.ins]: [IPATYPE_KEY, 4],
  [ipatypeEnum.telegram]: [IPATYPE_KEY, 1],
  [ipatypeEnum.facebook]: [IPATYPE_KEY, 3],
  [ipatypeEnum.twitter]: [],
  [ipatypeEnum.whatsapp]: [IPATYPE_KEY, 2],
  [ipatypeEnum.kwai]: [IPATYPE_KEY, 6],
  [ipatypeEnum.bluesky]: [IPATYPE_KEY, 5],
};
